/* ===== Quiz devis — L'Atelier Banaat — moteur JS ===== */
(function () {
  'use strict';

  var root = document.getElementById('quiz-root');
  if (!root) return;

  var FORMSPREE_ENDPOINT = root.getAttribute('data-formspree-endpoint');

  var PARCOURS_STEPS = {
    mariee: ['mariee-style', 'mariee-budget', 'mariee-mensurations', 'mariee-personnalisation', 'mariee-bustier', 'mariee-manches', 'mariee-embellissement', 'mariee-traine', 'mariee-tissus', 'mariee-message'],
    enfant: ['enfant-age', 'enfant-budget', 'enfant-mensurations', 'enfant-couleur', 'enfant-style', 'enfant-message'],
    melhfa: ['melhfa-occasion', 'melhfa-budget', 'melhfa-modele', 'melhfa-mensurations', 'melhfa-couleur', 'melhfa-galon', 'melhfa-traine', 'melhfa-message']
  };

  var LABELS = {
    type_creation: { mariee: 'Robe de mariée', enfant: 'Robe de cérémonie enfant', melhfa: 'Melhfa Chaoui' },
    mariee_style: { princesse: 'Princesse', sirene: 'Sirène', 'droite-fluide': 'Droite fluide', boheme: 'Bohème' },
    mariee_budget: { '1000-2000': '1 000 € à 2 000 €', '2000-3000': '2 000 € à 3 000 €', '3000+': 'Plus de 3 000 €' },
    mariee_personnalisation: { reproduction: "Reproduction d'un modèle existant", inspiree: "Inspirée d'un modèle existant", unique: 'Création totalement unique' },
    mariee_bustier: { carre: 'Carré', v: 'V', 'coeur-bretelles': 'Cœur & bretelles', arrondi: 'Arrondi', coeur: 'Cœur' },
    mariee_manches: { sans: 'Sans manches', courtes: 'Courtes', bretelles: 'Bretelles', '3-4': '3/4', longues: 'Longues' },
    mariee_embellissement: { epuree: 'Très épurée', 'quelques-details': 'Quelques détails décoratifs', chargee: 'Très chargée', 'ne-sait-pas': 'Je ne sais pas encore' },
    mariee_traine: { oui: 'Oui', non: 'Non' },
    mariee_tissus: { satin: 'Satin', dentelle: 'Dentelle', tulle: 'Tulle', mousseline: 'Mousseline', soie: 'Soie', 'ne-sait-pas': 'Je ne sais pas encore' },
    enfant_age: { '0-1': '0 à 1 an', '1-2': '1 à 2 ans', '2-4': '2 à 4 ans', '4-6': '4 à 6 ans', '6-8': '6 à 8 ans', '8-10': '8 à 10 ans' },
    enfant_budget: { '100-200': '100 € à 200 €', '200-350': '200 € à 350 €', '350-500': '350 € à 500 €', '500+': 'Plus de 500 €' },
    enfant_couleur: { rouge: 'Rouge', orange: 'Orange', jaune: 'Jaune', vert: 'Vert', bleu: 'Bleu', violet: 'Violet', marron: 'Marron', rose: 'Rose', blanc: 'Blanc', noir: 'Noir', gris: 'Gris' },
    enfant_style: { princesse: 'Princesse', boheme: 'Bohème', 'droite-fluide': 'Droite fluide', trapeze: 'Trapèze', sirene: 'Sirène' },
    melhfa_occasion: { mariee: 'Mariée', invitee: 'Invitée' },
    melhfa_budget: { '150-250': '150 € à 250 €', '250-450': '250 € à 450 €', '450-650': '450 € à 650 €', '650-850': '650 € à 850 €', '850+': 'Plus de 850 €' },
    melhfa_modele: { volumineuse: 'Volumineuse / princesse', sirene: 'Sirène' },
    melhfa_couleur: { rouge: 'Rouge', orange: 'Orange', jaune: 'Jaune', vert: 'Vert', bleu: 'Bleu', violet: 'Violet', rose: 'Rose', marron: 'Marron', gris: 'Gris', noir: 'Noir', blanc: 'Blanc' },
    melhfa_galon: { piecettes: 'Galon à piécettes', berbere: 'Galon berbère', 'ne-sait-pas': 'Je ne sais pas encore' },
    melhfa_traine: { oui: 'Oui', non: 'Non' },
    autre_creation: { oui: 'Oui', non: 'Non' }
  };

  var QUESTION_TITLES = {
    mariee_style: 'Style de robe',
    mariee_budget: 'Budget maximum',
    mariee_personnalisation: 'Personnalisation',
    mariee_bustier: 'Forme du bustier',
    mariee_manches: 'Manches',
    mariee_embellissement: 'Embellissement',
    mariee_traine: 'Traîne',
    mariee_tissus: 'Tissus souhaités',
    mariee_poids: 'Poids approximatif',
    mariee_taille: 'Taille approximative',
    mariee_message: 'Informations complémentaires',
    enfant_age: "Âge de l'enfant",
    enfant_budget: 'Budget maximum',
    enfant_couleur: 'Couleur souhaitée',
    enfant_style: 'Style souhaité',
    enfant_poids: 'Poids approximatif',
    enfant_taille: 'Taille approximative',
    enfant_message: 'Informations complémentaires',
    melhfa_occasion: 'Occasion',
    melhfa_budget: 'Budget maximum',
    melhfa_modele: 'Modèle souhaité',
    melhfa_couleur: 'Couleur souhaitée',
    melhfa_galon: 'Style de galon',
    melhfa_traine: 'Traîne',
    melhfa_poids: 'Poids approximatif',
    melhfa_taille: 'Taille approximative',
    melhfa_message: 'Informations complémentaires'
  };

  var state = {
    contact: {},
    creations: [],
    currentAnswers: {},
    history: [],
    currentStep: null,
    isSubmitting: false
  };

  var body = document.getElementById('q-body');
  var stepCountEl = document.getElementById('q-step-count');
  var progressFill = document.getElementById('q-progress-fill');
  var quizShell = document.querySelector('[data-screen-group="quiz"]');

  function showScreen(name) {
    document.querySelectorAll('.q-screen').forEach(function (s) {
      s.hidden = s.dataset.screen !== name;
    });
    quizShell.hidden = name !== 'quiz';
  }

  function getStepEl(stepName) {
    return body.querySelector('[data-step="' + stepName + '"]');
  }

  function activateStep(stepName) {
    body.querySelectorAll('.q-step').forEach(function (s) {
      s.classList.remove('is-active');
    });

    var el = getStepEl(stepName);
    if (el) el.classList.add('is-active');

    state.currentStep = stepName;
    updateProgress();
    updateBottomBar();
    window.scrollTo(0, 0);
  }

  function updateProgress() {
    var flatSteps = getFlatStepSequence();
    var idx = flatSteps.indexOf(state.currentStep);
    var total = flatSteps.length;

    if (idx === -1) {
      progressFill.style.width = '0%';
      stepCountEl.textContent = '';
      return;
    }

    var pct = Math.round(((idx + 1) / total) * 100);
    progressFill.style.width = pct + '%';
    stepCountEl.textContent = 'Étape ' + (idx + 1) + ' / ' + total;
  }

  function getFlatStepSequence() {
    var base = ['presentation', 'type-creation'];
    var type = state.currentAnswers.type_creation;

    if (type && PARCOURS_STEPS[type]) {
      base = base.concat(PARCOURS_STEPS[type]);
    }

    base.push('autre-creation', 'recapitulatif');
    return base;
  }

  function updateBottomBar() {
    var btnNext = document.querySelector('[data-action="next"]');
    if (!btnNext) return;

    btnNext.querySelector('span').textContent =
      state.currentStep === 'recapitulatif' ? 'Envoyer' : 'Suivant';
  }

  function goNext() {
    if (!validateCurrentStep()) return;

    saveCurrentStepData();

    var next = computeNextStep(state.currentStep);

    if (next === 'SUBMIT') {
      submitQuiz();
      return;
    }

    state.history.push(state.currentStep);
    activateStep(next);
  }

  function goBack() {
    if (state.history.length === 0) {
      showScreen('accueil');
      return;
    }

    var prev = state.history.pop();
    activateStep(prev);
  }

  function computeNextStep(current) {
    var type = state.currentAnswers.type_creation;

    if (current === 'presentation') return 'type-creation';

    if (current === 'type-creation') {
      if (!type || !PARCOURS_STEPS[type]) return 'type-creation';
      return PARCOURS_STEPS[type][0];
    }

    if (type && PARCOURS_STEPS[type]) {
      var seq = PARCOURS_STEPS[type];
      var idx = seq.indexOf(current);

      if (idx !== -1 && idx < seq.length - 1) return seq[idx + 1];
      if (idx === seq.length - 1) return 'autre-creation';
    }

    if (current === 'autre-creation') {
      commitCurrentCreation();

      if (state.currentAnswers.autre_creation === 'oui') {
        resetForNewCreation();
        return 'type-creation';
      }

      return 'recapitulatif';
    }

    if (current === 'recapitulatif') return 'SUBMIT';

    return current;
  }

  function commitCurrentCreation() {
    var type = state.currentAnswers.type_creation;

    state.creations.push({
      type: type,
      answers: JSON.parse(JSON.stringify(state.currentAnswers))
    });
  }

  function resetForNewCreation() {
    state.currentAnswers = {};

    body.querySelectorAll('.q-pick-card.is-selected, .q-color-card.is-selected').forEach(function (c) {
      c.classList.remove('is-selected');
    });

    body.querySelectorAll('.q-input, .q-textarea').forEach(function (i) {
      if (i.name && i.name.match(/^(mariee_|enfant_|melhfa_)/)) i.value = '';
    });
  }

  function validateCurrentStep() {
    var el = getStepEl(state.currentStep);
    if (!el) return true;

    var requiredInputs = el.querySelectorAll('input[required]');

    for (var i = 0; i < requiredInputs.length; i++) {
      if (!requiredInputs[i].value.trim()) {
        requiredInputs[i].focus();
        requiredInputs[i].style.outline = '1.5px solid #B5342B';
        return false;
      }
      requiredInputs[i].style.outline = '';
    }

    if (state.currentStep === 'type-creation' && !state.currentAnswers.type_creation) return false;
    if (state.currentStep === 'autre-creation' && !state.currentAnswers.autre_creation) return false;

    return true;
  }

  function saveCurrentStepData() {
    var el = getStepEl(state.currentStep);
    if (!el) return;

    el.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="date"], textarea').forEach(function (input) {
      if (!input.name) return;

      if (state.currentStep === 'presentation') {
        state.contact[input.name] = input.value;
      } else {
        state.currentAnswers[input.name] = input.value;
      }
    });
  }

  function initPickCards() {
    body.addEventListener('click', function (e) {
      var card = e.target.closest('.q-pick-card, .q-color-card');
      if (!card) return;

      var group = card.dataset.pickGroup;
      var value = card.dataset.value;
      var isMulti = card.dataset.multi === 'true';

      if (isMulti) {
        var current = state.currentAnswers[group] || [];
        var isAlreadySelected = card.classList.contains('is-selected');

        if (isAlreadySelected) {
          card.classList.remove('is-selected');
          current = current.filter(function (v) {
            return v !== value;
          });
        } else {
          if (group === 'mariee_tissus') {
            if (value === 'ne-sait-pas') {
              body.querySelectorAll('[data-pick-group="mariee_tissus"]').forEach(function (c) {
                c.classList.remove('is-selected');
              });
              current = [];
            } else {
              var unsureCard = body.querySelector('[data-pick-group="mariee_tissus"][data-value="ne-sait-pas"]');

              if (unsureCard) unsureCard.classList.remove('is-selected');

              current = current.filter(function (v) {
                return v !== 'ne-sait-pas';
              });

              if (current.length >= 2) {
                alert('Vous pouvez sélectionner 2 tissus maximum.');
                return;
              }
            }
          }

          card.classList.add('is-selected');
          current.push(value);
        }

        state.currentAnswers[group] = current;
      } else {
        var groupCards = body.querySelectorAll('[data-pick-group="' + group + '"]');

        groupCards.forEach(function (c) {
          c.classList.remove('is-selected');
        });

        card.classList.add('is-selected');
        state.currentAnswers[group] = value;

        if (group === 'type_creation' || group === 'autre_creation') {
          setTimeout(function () {
            goNext();
          }, 220);
        }
      }
    });
  }

  function renderRecap() {
    var container = document.getElementById('q-recap-content');
    container.innerHTML = '';

    var contactBlock = document.createElement('div');
    contactBlock.className = 'q-recap-block';

    contactBlock.innerHTML =
      '<div class="q-recap-head"><span class="q-recap-head-title">Vos informations</span>' +
      '<button type="button" class="q-recap-edit" data-edit-step="presentation">Modifier</button></div>' +
      recapRow('Nom', state.contact.nom) +
      recapRow('Téléphone', state.contact.telephone) +
      recapRow('E-mail', state.contact.email) +
      recapRow('Date événement', state.contact.date_evenement) +
      recapRow('Pays', state.contact.pays);

    container.appendChild(contactBlock);

    state.creations.forEach(function (creation, idx) {
      var block = document.createElement('div');
      block.className = 'q-recap-block';

      var title = 'Création ' + (idx + 1) + ' — ' + LABELS.type_creation[creation.type];
      var rows = '';

      Object.keys(creation.answers).forEach(function (key) {
        if (key === 'type_creation') return;

        var label = QUESTION_TITLES[key] || key;
        var raw = creation.answers[key];
        var displayValue;

        if (Array.isArray(raw)) {
          displayValue = raw.map(function (v) {
            return (LABELS[key] && LABELS[key][v]) || v;
          }).join(', ');
        } else {
          displayValue = (LABELS[key] && LABELS[key][raw]) || raw;
        }

        if (displayValue) rows += recapRow(label, displayValue);
      });

      block.innerHTML =
        '<div class="q-recap-head"><span class="q-recap-head-title">' + title + '</span>' +
        '<button type="button" class="q-recap-edit" data-edit-creation="' + idx + '">Modifier</button></div>' +
        rows;

      container.appendChild(block);
    });
  }

  function recapRow(label, value) {
    if (!value) return '';

    return '<div class="q-recap-row"><span class="q-recap-row-label">' +
      label +
      '</span><span class="q-recap-row-value">' +
      escapeHtml(String(value)) +
      '</span></div>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function submitQuiz() {
    if (state.isSubmitting) return;

    state.isSubmitting = true;

    var btn = document.querySelector('[data-action="next"]');
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Envoi en cours...';

    var formData = new FormData();

    formData.append('nom', state.contact.nom || '');
    formData.append('telephone', state.contact.telephone || '');
    formData.append('email', state.contact.email || '');
    formData.append('date_evenement', state.contact.date_evenement || '');
    formData.append('pays', state.contact.pays || '');
    formData.append('_subject', 'Nouvelle demande de devis – ' + state.creations.map(function (c) {
      return LABELS.type_creation[c.type];
    }).join(', '));

    state.creations.forEach(function (creation, idx) {
      var prefix = 'creation_' + (idx + 1) + '_';

      formData.append(prefix + 'type', LABELS.type_creation[creation.type]);

      Object.keys(creation.answers).forEach(function (key) {
        if (key === 'type_creation') return;

        var raw = creation.answers[key];

        var value = Array.isArray(raw)
          ? raw.map(function (v) {
              return (LABELS[key] && LABELS[key][v]) || v;
            }).join(', ')
          : ((LABELS[key] && LABELS[key][raw]) || raw);

        formData.append(prefix + (QUESTION_TITLES[key] || key), value || '');
      });
    });

    if (!FORMSPREE_ENDPOINT) {
      console.warn('Aucun endpoint Formspree configuré.');
      finishSubmit(false);
      return;
    }

    fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        finishSubmit(response.ok);
      })
      .catch(function () {
        finishSubmit(false);
      });
  }

  function finishSubmit(success) {
    state.isSubmitting = false;

    var btn = document.querySelector('[data-action="next"]');
    btn.disabled = false;
    btn.querySelector('span').textContent = 'Envoyer';

    if (success) {
      showScreen('confirmation');
    } else {
      showScreen('erreur');
    }
  }

  document.querySelector('[data-action="start"]').addEventListener('click', function () {
    showScreen('quiz');
    activateStep('presentation');
  });

  document.querySelector('[data-action="next"]').addEventListener('click', function () {
    if (state.currentStep === 'recapitulatif') {
      submitQuiz();
    } else {
      goNext();
    }
  });

  document.querySelector('[data-action="back"]').addEventListener('click', goBack);

  document.querySelector('[data-action="retry-submit"]').addEventListener('click', function () {
    showScreen('quiz');
    activateStep('recapitulatif');
  });

  body.addEventListener('click', function (e) {
    var editBtn = e.target.closest('[data-edit-step]');

    if (editBtn) {
      activateStep(editBtn.dataset.editStep);
      return;
    }

    var editCreation = e.target.closest('[data-edit-creation]');

    if (editCreation) {
      var idx = parseInt(editCreation.dataset.editCreation, 10);
      var creation = state.creations[idx];

      if (creation) {
        state.creations.splice(idx, 1);
        state.currentAnswers = JSON.parse(JSON.stringify(creation.answers));
        activateStep('type-creation');

        setTimeout(function () {
          var card = body.querySelector('[data-pick-group="type_creation"][data-value="' + creation.type + '"]');
          if (card) card.classList.add('is-selected');
        }, 50);
      }
    }
  });

  var originalActivateStep = activateStep;

  activateStep = function (stepName) {
    originalActivateStep(stepName);

    if (stepName === 'recapitulatif') {
      renderRecap();
    }
  };

  initPickCards();
})();